"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownToggle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const faChevronDown_1 = require("@fortawesome/free-solid-svg-icons/faChevronDown");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = require("react");
const Box_1 = require("../Box");
const Button_1 = require("../Button");
const Dropdown_1 = require("../Dropdown");
const DropdownToggle = (_a) => {
    var { children, chevron } = _a, props = __rest(_a, ["children", "chevron"]);
    const { toggle } = react_1.useContext(Dropdown_1.DropdownContext);
    return (jsx_runtime_1.jsxs(Button_1.Button, Object.assign({ display: "flex", backgroundColor: "#fff", color: "#000", width: 1, textAlign: "left" }, props, { onClick: toggle }, { children: [jsx_runtime_1.jsx(Box_1.Box, Object.assign({ shouldTruncate: true }, { children: children }), void 0),
            jsx_runtime_1.jsx(Box_1.Box, Object.assign({ flex: 1, textAlign: "right", marginLeft: 2 }, { children: chevron ? jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: faChevronDown_1.faChevronDown }, void 0) : null }), void 0)] }), void 0));
};
exports.DropdownToggle = DropdownToggle;
//# sourceMappingURL=index.js.map